<template>
    <BreadCrumb PageTitle="Détails" />
    <ViewAssign />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ViewAssign from "@/components/Assignations/ViewAssign.vue";

export default defineComponent({
    name: "ViewAssPage",
    components: {
        BreadCrumb,
        ViewAssign,
    },
});
</script>